import { useLocation } from '@/hooks/useLocation';
import { ROUTE_PLANS } from '@/constants/routes';

const UTM_VARIANT_VALUES = [
  'UEVrM6c5BkW62UHs6hVq4Q', // limit hitters
  'yKkJNEN9V77mADZU5k59gw', // easter 2025 promo
] as const;

const isGroupUtmValue = (
  param: string | undefined
): param is (typeof UTM_VARIANT_VALUES)[number] => {
  return UTM_VARIANT_VALUES.includes(
    param as (typeof UTM_VARIANT_VALUES)[number]
  );
};

export const useUtmExperiment = () => {
  const location = useLocation();
  const isUtmExperiment =
    location.type === ROUTE_PLANS && isGroupUtmValue(location.query?.group);
  return { isUtmExperiment };
};
